<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm ngày nghỉ</div>
      <div v-else>Chỉnh sửa ngày nghỉ</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm ngày nghỉ'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
      <div class="p-field p-grid" style="padding-top: 15px;">
        <div class="p-col-5 p-grid">
          <label class="p-col-4 txt-left">Ngày nghỉ (*)</label>
          <div class="p-col-8">
            <Calendar v-model="date_off" dateFormat="dd/mm/yy" placeholder="Chọn ngày nghỉ" :showIcon="true"/>
            <small
              v-if="validationErrors && validationErrors['date_off']"
              class="p-invalid"
            >{{validationErrors['date_off']}}</small>
          </div>
        </div>
        <div class="p-col-2">
        </div>
        <div class="p-col-5 p-grid">
          <label class="p-col-4 txt-left">Tiêu đề ngày nghỉ (*)</label>
          <div class="p-col-8">
            <InputText v-model="name"  id="name" type="text" class="p-col-width" placeholder="Nhập tiêu đề ngày nghỉ" />
            <small
              v-if="validationErrors && validationErrors['name']"
              class="p-invalid"
            >{{validationErrors['name']}}</small>
          </div>
        </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
import moment from "moment-timezone";
import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      date_off: null,
      name: '',
      listHoliday: []
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.holiday_setting_id = this.$route.params.id
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      console.log('-------------------------------')
      this.validationErrors = {};
      var has_error = false
      if (this.name === '') {
        this.validationErrors['name'] = 'Vui lòng nhập tiêu đề ngày nghỉ';
        has_error = true
      }
      if (this.date_off == null) {
        this.validationErrors['date_off'] = 'Vui lòng chọn ngày nghỉ';
        has_error = true
      }
      return has_error
    },
    async analyzeData() {
      console.log('dâdadadadadadad')
      var data_holiday_setting = {}
        data_holiday_setting['name'] = this.name
        data_holiday_setting['date_off'] = moment(this.date_off).add(1, 'days')

      return data_holiday_setting
    },
    async analyzeDataEdit() {
      var data_holiday_setting = {}
        data_holiday_setting['name'] = this.name
        data_holiday_setting['date_off'] = moment(this.date_off).add(1, 'days')
      return data_holiday_setting
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_holiday_setting = await this.analyzeData()

        var query = `mutation MyMutation($objects: [holiday_setting_insert_input!]!) {
            insert_holiday_setting(objects: $objects) {
              affected_rows
              returning {
                id
                name
                date_off
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: [data_holiday_setting]
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-holiday_setting'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_holiday_setting_update = await this.analyzeDataEdit()
        // let group_permission_id = await this.getGroupPerId()
        let query = `mutation MyMutation($holiday_setting_id: Int!, $holiday_setting_update: holiday_setting_set_input) {
          update_holiday_setting(where: {id: {_eq: $holiday_setting_id}}, _set: $holiday_setting_update) {
            affected_rows
            returning {
              id
              name
              date_off
            }
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              holiday_setting_id: this.holiday_setting_id,
              holiday_setting_update: data_holiday_setting_update,
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-holiday_setting'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    holiday_setting: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            holiday_setting(where: {id: {_eq: $id}}) {
              id
              name
              date_off
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      update(data) {
        if(data.holiday_setting){
          this.listHoliday = data.holiday_setting
          this.name = this.listHoliday[0].name
          this.date_off = new Date(this.listHoliday[0].date_off)
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
